export default __webpack_public_path__ + "static/media/p2-tip-box-open.8cdb9f81.svg";